export var ContentCardLayout;
(function (ContentCardLayout) {
    ContentCardLayout["_1x_1y"] = "1x_1y";
    ContentCardLayout["_1x_2y"] = "1x_2y";
    ContentCardLayout["_1x_3y"] = "1x_3y";
    ContentCardLayout["_2x_2y"] = "2x_2y";
})(ContentCardLayout || (ContentCardLayout = {}));
